var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { "z-index": "3100 !important" },
      attrs: { id: "go-modal-logout", tabindex: "-1", "aria-hidden": "true" },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-confirm" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("p", { staticClass: "lead" }, [
                _vm._v(_vm._s(_vm.$t("logout.title"))),
              ]),
              _vm._v(" "),
              _c("P", [_vm._v(_vm._s(_vm.$t("logout.description")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                attrs: {
                  id: "logoutButton",
                  type: "button",
                  "data-dismiss": "modal",
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("logout.cancelButtonText")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.logout },
              },
              [_vm._v(_vm._s(_vm.$t("logout.logoutButtonText")))]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }